import _path from "ramda/es/path";
import _compose from "ramda/es/compose";
import s3Event from './s3Event';
export default _compose(_path(['bucket', 'name']), s3Event);